export default "__VITE_ASSET__Dx5H92sa__"